<div class="editable-grid-wrapper">
  <table class="editable-grid-table">
    <thead>
      <tr>
        <th *ngIf="showSelectColumn" class="select-col">
          <input type="checkbox" [checked]="isAllSelected()" (change)="toggleSelectAll($event)" />
        </th>
        <th *ngFor="let col of columns">{{ col.label }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of rows">
        <td *ngIf="showSelectColumn" class="select-col">
          <input type="checkbox" [checked]="row._include" (change)="toggleSelectRow(row)" />
        </td>
        <td *ngFor="let col of columns">
          <select *ngIf="col.type === 'select'" [(ngModel)]="row[col.key]" (ngModelChange)="onCellChange()"
            class="grid-cell-input" [class.invalid-input]="isRequiredMissing(row, col)">
            <option *ngFor="let opt of col.options" [value]="opt">{{ opt }}</option>
          </select>
          <input *ngIf="col.type === 'text'" type="text" [(ngModel)]="row[col.key]" (ngModelChange)="onCellChange()"
            class="grid-cell-input" [class.low-confidence]="isLowConfidence(row, col.key)"
            [class.invalid-input]="isRequiredMissing(row, col)" placeholder="N/A" />
        </td>
      </tr>
      <tr *ngIf="rows.length === 0">
        <td [attr.colspan]="columns.length + (showSelectColumn ? 1 : 0)" class="text-center">No rows</td>
      </tr>
    </tbody>
  </table>
</div>